import _classCallCheck from "C:/Users/lego1/github/CPA_submitted/node_modules/@babel/runtime/helpers/esm/classCallCheck";

/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
import { getVecChannels } from './packing_util';
import { getCoordsDataType } from './shader_compiler';
export var TransposePackedProgram = function TransposePackedProgram(aShape, newDim) {
  _classCallCheck(this, TransposePackedProgram);

  this.variableNames = ['A'];
  this.packedInputs = true;
  this.packedOutput = true;
  var outputShape = new Array(aShape.length);

  for (var i = 0; i < outputShape.length; i++) {
    outputShape[i] = aShape[newDim[i]];
  }

  this.outputShape = outputShape;
  this.rank = outputShape.length;

  if (this.rank > 6) {
    throw Error("Packed transpose for rank ".concat(this.rank, " is not yet supported."));
  }

  var dtype = getCoordsDataType(this.rank);
  var outputOrder = getVecChannels('rc', this.rank);
  var switchedOrder = new Array(this.rank);

  for (var _i = 0; _i < newDim.length; _i++) {
    switchedOrder[newDim[_i]] = outputOrder[_i];
  }

  var innerDims = "vec2(".concat(switchedOrder.slice(-2).join(), ")");
  var nextColumn = "++".concat(outputOrder[this.rank - 1], " < ").concat(outputShape[this.rank - 1]);
  var getc = "getChannel(getA(".concat(switchedOrder.join(), "), ").concat(innerDims, ")");
  this.userCode = "\n    void main() {\n      ".concat(dtype, " rc = getOutputCoords();\n      vec4 result = vec4(0.);\n      result[0] = ").concat(getc, ";\n      if(").concat(nextColumn, ") {\n        result[1] = ").concat(getc, ";\n      }\n      --").concat(outputOrder[this.rank - 1], ";\n      if(++").concat(outputOrder[this.rank - 2], " < ").concat(outputShape[this.rank - 2], ") {\n        result[2] = ").concat(getc, ";\n        if(").concat(nextColumn, ") {\n          result[3] = ").concat(getc, ";\n        }\n      }\n      setOutput(result);\n    }\n    ");
};